import { InsuranceInformationFieldNames } from '@contracts/order/fields/InsuranceInformationFields';
import {
  BooleanField,
  DateField,
  PositiveIntegerField,
  StringField,
} from '@src/permitField/PermitFields';

export class InsuranceCompanyField extends StringField {
  public static fieldName = InsuranceInformationFieldNames.InsuranceCompany;
}

export class InsuranceAddressNumberField extends StringField {
  public static fieldName =
    InsuranceInformationFieldNames.InsuranceAddressNumber;
}

export class InsuranceEffectiveDateField extends DateField {
  public static fieldName: string =
    InsuranceInformationFieldNames.InsuranceEffectiveDate;
}

export class InsuranceExperienceDateField extends DateField {
  public static fieldName: string =
    InsuranceInformationFieldNames.InsuranceExpirationDate;
}

export class InsurancePolicyNumberField extends StringField {
  public static fieldName =
    InsuranceInformationFieldNames.InsurancePolicyNumber;
}

export class InsuranceCoverageAmountField extends PositiveIntegerField {
  public static fieldName =
    InsuranceInformationFieldNames.InsuranceCoverageAmount;
}

export class InsuranceAgentField extends StringField {
  public static fieldName = InsuranceInformationFieldNames.InsuranceAgentName;
}

export class InsurancePhoneNumberField extends StringField {
  public static fieldName = InsuranceInformationFieldNames.InsurancePhoneNumber;
}

export class InsuranceIsOnFileWithStateField extends BooleanField {
  public static fieldName =
    InsuranceInformationFieldNames.InsuranceIsOnFileWithState;
}

export const insuranceInformationFields = {
  [InsuranceCompanyField.fieldName]: InsuranceCompanyField.validator,
  [InsuranceAddressNumberField.fieldName]:
    InsuranceAddressNumberField.validator,
  [InsuranceEffectiveDateField.fieldName]:
    InsuranceEffectiveDateField.validator,
  [InsuranceExperienceDateField.fieldName]:
    InsuranceExperienceDateField.validator,
  [InsurancePolicyNumberField.fieldName]: InsurancePolicyNumberField.validator,
  [InsuranceCoverageAmountField.fieldName]:
    InsuranceCoverageAmountField.validator,
  [InsuranceAgentField.fieldName]: InsuranceAgentField.validator,
  [InsurancePhoneNumberField.fieldName]: InsurancePhoneNumberField.validator,
  [InsuranceIsOnFileWithStateField.fieldName]:
    InsuranceIsOnFileWithStateField.validator,
};
